import { Grid } from "@mui/material";
import { SelectField } from "../../../../utils/FormFields";

const EquipmentTreatment = ({ availableEquipment }: any) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <SelectField name={`Equipment.EquipmentID`} label="Equipment" data={availableEquipment} fullWidth />
      </Grid>      
    </>
  );
};

export default EquipmentTreatment;
